import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiConfigurationService } from '../../shared/services/api-configuration.service';
import { ApiProjectTypeService } from '../../shared/services/api-project-type.service';
import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { AddItemBackofficeDialogComponent } from '../add-item-backoffice-dialog/add-item-backoffice-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { AuthService } from '../../shared/services/auth.service';
import { ConfigurationDialogComponent } from '../configuration-dialog/configuration-dialog.component';
import { ParameterizationDialogComponent } from '../parameterization-dialog/parameterization-dialog.component';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { Profile } from 'src/app/models/Profile';
import { Permission } from '../../shared/security/permission';


@Component({
  standalone: false,
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {
  
  Permission = Permission; // Make enum accessible in template
  
  variables: any;
  arr1: any = [];


  // Form and sub form, needed to link parent form with this component form.
  form: any;
  @Input() canEditCatalog: boolean = false;
  subForm: any;
  private sub: Subscription | undefined = undefined;
  tecnologia: any; //Which technology is being created or edited.


  @Input() listItem: any = [] //List of configurations choosen by the user.


  @Input() listItemParams: any = [] //List of parameters choosen by the user.
  @Input() profiles: Profile[] = [];


  preDefined: any[] = []; //Predefined list of configurations
  preDefinedParams: any[] = []; //Predefined list of parameters

  alreadyInConfigs: any[] = []; //List of project types already in Configs
  alreadyInParams: any[] = []; //List of project types already in Params


  constructor(private _formBuilder: FormBuilder,
    private ctrlContainer: FormGroupDirective,
    private stepperService: StepperServiceService,
    public dialog: MatDialog,
    public authService: AuthService,
    private route: ActivatedRoute,
    private infoBar: InfoBarWithStatusService,
    private configurationService: ApiConfigurationService,
    private languageService: LanguageService,
    private techService: TecnologiasService,
    private _snackBar: MatSnackBar,
    private UsersManagementService: UsersManagementService,
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.sub = this.stepperService.dataChange.subscribe((data: any) => {
      this.tecnologia = data;
    });

    //Link sub form and form
    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.form = this.ctrlContainer.form;
    this.form.addControl("formGroup4", this.subForm);
    this.subForm.status = "INVALID";
    this.form.status = "INVALID";
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.variables) {
      this.preDefined = [
        { name: this.variables.configDevelop },
        { name: this.variables.configQuality },
        { name: this.variables.configPreProd },
        { name: this.variables.configProd },
        { name: this.variables.other },

      ];
    }

    if (changes.listItem?.currentValue)
      this.alreadyInConfigs = changes.listItem.currentValue;
    if (changes.listItemParams?.currentValue)
      this.alreadyInParams = changes.listItemParams.currentValue;
  }



  addProjectConfig() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;


    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const data = {
      title: this.variables.add + ' ' + this.variables.config,
      list: this.preDefined,
      listInConfigs: this.alreadyInConfigs,
      isEdit: false,
      isActionType: false,
      isConfigurationType: true,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(ConfigurationDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        const obj = {
          name: result.data.name,
          complexity: result.data.complexity.toFixed("2"),
          profileId: result.data.profileId || null,
        }
        this.listItem.push(obj);
      }
    });
  }

  addParams() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItemParams;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    // Prepare data to be passed to dialog component
    var title: any = this.variables.add + ' ' + this.variables.parameterization;

    const data = {
      title: title,
      listInDB: this.alreadyInParams,
      isEdit: false,
      isActionType: false,
      isConfigurationType: true,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(ParameterizationDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        const obj = {
          name: result.data.name,
          complexity: result.data.complexity,
          profileId: result.data.profileId || null,
        }
        this.listItemParams.push(obj);
      }
    })
  }

  openDialogEditProjectConfig(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }


    const data = {
      title: this.variables.changeConfiguration + ':',
      configName: item.name,
      list: this.preDefined,
      listInConfigs: this.alreadyInConfigs,
      isEdit: true,
      item: item,
      itemIndex: index,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(ConfigurationDialogComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {
      // Get result and update item on the arr
      if (result?.data) {


        this.listItem.forEach((v: any) => {
          if (v.name === item.name && v.complexity === item.complexity) {
            v.name = result.data.name;
            v.complexity = result.data.complexity.toFixed("2");
            v.profileId = result.data.profileId || null;
          }
        })
        this.infoBar.showSnackbar(this.variables.configEditedSuccessfully, ['successful-snackbar'], 4000);


      }

    })
  }


  openDialogEditProjectParams(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItemParams;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }

    const data = {
      title: this.variables.changeParameters + ': ' + item.name,
      list: this.preDefinedParams,
      listInDB: this.alreadyInParams,
      isEdit: true,
      type: 'edit',
      item: item,
      itemIndex: index,
      isActionType: false,
      isConfigurationType: true,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(ParameterizationDialogComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {
      // Get result and update item on the arr
      if (result?.data) {


        this.listItemParams.forEach((v: any) => {
          if (v.name === item.name && v.complexity === item.complexity) {
            v.name = result.data.name;
            v.complexity = result.data.complexity;
            v.profileId = result.data.profileId || null;
          }
        })
        this.infoBar.showSnackbar(this.variables.paramEditedSuccessfully, ['successful-snackbar'], 4000);

      }
    })
  }


  openDialogRemove(name: string, type: String) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      // Remove item
      if (result === 'true') {

        if (type === 'configuration') {
          this.listItem = this.listItem.filter((item: any) => {
            return item.name != name;
          })
        }
        else {
          this.listItemParams = this.listItemParams.filter((item: any) => {
            return item.name != name;
          })
        }

        this.infoBar.showSnackbar(this.variables.itemDeleted, ['successful-snackbar'], 4000);

      }
    });
  }

  getProfileName(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? profile.name : '-';
  }

}
